import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { CreateConfig } from "../../DetailsTab/CreateConfig.logic";
import { useUser } from "../../../../../AuthContext";
import { CreateOutputConfigView } from "./CreateOutputConfig.View";
import { saveOutputConfig } from "./Script";

/**
 * Responsible for rendering the output config button
 */
export const CreateOutputConfig: React.FC = () => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const [
    extractState,
    outputConfig
  ] = useSelector((state: IRootState) => [
    state.extractState,
    state.outputConfig
  ], shallowEqual);
  const selectedExtract = extractState.selectedExtract;
  const extractGuid = selectedExtract?.extractGuid as string;
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  /**
   * Toggle dialog show
   */
  const OnAddNewOutputConfig = (): void => {
    setShow(true);
  };

  /**
   * To close the dialog
   */
  const handleDialogClose = (): void => {
    setShow(false);
  };

  /**
   * To close the dialog
   */
  const handleSave = (): void => {
    saveOutputConfig(
      dispatch,
      translate,
      outputConfig.formData,
      extractGuid,
      env,
      user?.token
    );
    handleDialogClose();
  };

  return (
    <>
      <CreateOutputConfigView
        OnAddNewOutputConfig={OnAddNewOutputConfig}
      />
      <CreateConfig
        showDialog={show}
        onClose={handleDialogClose}
        onSave={handleSave}
      />
    </>
  );
};
